export default "__VITE_PUBLIC_ASSET__b8b3ca23__"